import Vue from 'vue';

export default {
  SET_PROFILE(state, orders) {
    Vue.set(state, 'profile', orders);
  },
};



// WEBPACK FOOTER //
// ./src/views/Profile/store/mutations.js